/**
 * @packageDocumentation
 * @module f1/array
 */

import { I } from '../core/immutable';

export interface Push {
  /**
   * Add a value to the top of a stack
   *
   * @public
   * @function f1.push
   * @param val the value to push
   * @param arr the stack of values
   * @example
   *
   * ```ts
   * push(4, [1, 2, 3]) => [1, 2, 3, 4]
   * ```
   *
   */
  <T>(val: T, arr: T[]): T[];
  <T>(val: T): (arr: T[]) => T[];
}

/**
 * @see Push
 */
export default <T>(val: T, arr: T[]): T[] => {
  const _arr = I.array(arr);

  _arr.push(val);
  return _arr;
};
